import cn from "classnames";

import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import ShareButtons from "@components/cms/ShareButtons/ShareButtons";
import EditableLink from "@components/cms/EditableLink/EditableLink";
import { specificBlockOptions } from "@components/cmsBlocks/configs";
import AdvBannerWidget from "@components/cmsWidgets/AdvBannerWidget/AdvBannerWidget";
import Latest from "@components/Latest/Latest";
import { useMediaQuery } from "@hooks/useMediaQuery";
import { useStore } from "@hooks/useZustandProvider";
import Editor from "@ui-kit/cms/Editor/Editor";
import Container from "@ui-kit/Container/Container";
import { getFileType } from "@utils/utils";

import GraphicFile from "./components/GraphicFile/GraphicFile";
import s from "./ContentBlock.module.scss";
const ContentBlock = ({ settings, data, updateField }) => {
  const { cms } = useStore();
  const { isMobile, isLaptopUp } = useMediaQuery();
  const { isEditMode } = cms.uiOptions;
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;

  const { title, image, link, buttonLink, showMore } = data;

  const { blockType } = settings.common;

  const {
    columns,
    component,
    componentPosition,
    componentContentType,
    titlePosition,
    showMoreLink,
    showShareButtons,
    typeOfLink,
    fullWidth,
    linkPosition,
  } = settings.specific;

  const isButtonTypeLink =
    typeOfLink?.value ===
    specificBlockOptions.content.typeOfLink.options[0].value;

  const isTitleOutside =
    titlePosition.value ===
      specificBlockOptions.content.titlePosition.options[0].value || isMobile;

  const enabledComponent =
    component?.value !== 4 && (isLaptopUp || component?.value === 1);

  const hasFile = component?.value === 1 && !!image.src;

  const isOnFullWidth = fullWidth?.value;
  const positionLinkValue = linkPosition?.value;

  const isRenderComponent =
    enabledComponent && component?.value === 1 ? image.src : true;

  const fileType = getFileType(image?.src || "");

  // const enabledPicture = picture.value !== "none" && columns.value > 1;

  let RenderComponent = null;

  let componentClassName = "";

  switch (component?.value) {
    case 1:
      componentClassName = cn(s.graphicFile);
      RenderComponent = (
        <GraphicFile
          fileType={fileType}
          isWidget={isWidget}
          isWidgetEditing={isWidgetEditing}
          updateField={updateField}
          isEditMode={isEditMode}
          file={image}
          isRenderComponent={isRenderComponent}
          enabledComponent={enabledComponent}
        />
      );
      break;
    case 2:
      componentClassName = cn(s.latest);
      RenderComponent = <Latest type={componentContentType?.value} />;
      break;
    case 3:
      componentClassName = cn(s.banner);
      RenderComponent = <AdvBannerWidget />;
      break;
    case 4:
      RenderComponent = null;
      break;
    default:
      RenderComponent = null;
  }

  // const pictureRight = enabledPicture && picture.value === "right"; // old
  const isComponentLeft =
    enabledComponent && componentPosition?.value === "left";

  // const renderTwoAndMoreColumns =
  //   (enabledPicture && columns.value === 3) ||
  //   (!enabledPicture && columns.value >= 2);

  // const renderThreeColumns = !enabledPicture && columns.value === 3;

  const updateShowMoreLink = (value) => {
    updateField({
      name: "link",
      value,
    });
  };

  return (
    <Container className={s.contentBlock}>
      <Container full={false}>
        <section>
          {isTitleOutside && (
            <BlockTitle
              settings={settings}
              field={{ title }}
              onChange={updateField}
              type={blockType}
            />
          )}
          <div
            className={cn(
              s.content,
              enabledComponent && s.enabledComponent,
              isRenderComponent && s.isRenderComponent,
              enabledComponent && isComponentLeft && s.isComponentLeft,
              !hasFile && s.noGraphicFileSrc,
              isOnFullWidth && s.fullWidth,
              s[positionLinkValue],
              componentClassName,
              s[`cols_${columns.value}`],
            )}
          >
            <div className={cn(s.texts, s[`cols_${columns.value}`])}>
              {!isTitleOutside && (
                <BlockTitle
                  settings={settings}
                  field={{ title }}
                  onChange={updateField}
                  type={blockType}
                />
              )}
              <div className={s.columns}>
                {Array(columns.value)
                  .fill()
                  .map((_, key) => {
                    const fieldKey = `content${key + 1}`;
                    return (
                      <div
                        className={cn(
                          s.column,
                          key === 0 && s.first,
                          key === 1 && s.second,
                          key === 2 && s.third,
                          key === 3 && s.fourth,
                        )}
                        key={key}
                      >
                        <Editor
                          field={{ [fieldKey]: data[fieldKey] }}
                          onChange={updateField}
                        />
                      </div>
                    );
                  })}
              </div>
              {showMoreLink.value && (
                <EditableLink
                  isButtonTypeLink={isButtonTypeLink}
                  link={link} // delete this after checking all blocks for the presence of this variable
                  data={showMore}
                  position={positionLinkValue}
                  onChange={updateShowMoreLink}
                  className={cn(s.showMore, s[positionLinkValue])}
                />
              )}
              {showShareButtons?.value && ( // TODO: remove '?' after merge default settings with current block settings
                <ShareButtons />
              )}
            </div>
            {/* {(isEditMode || isRenderComponent) && ( */}
            {enabledComponent && (
              <div
                className={cn(
                  s.component,
                  fileType && s[fileType],
                  componentClassName,
                )}
              >
                {RenderComponent}
              </div>
            )}
          </div>
        </section>
      </Container>
    </Container>
  );
};

export default ContentBlock;
